import { Renderer2 } from '@angular/core';

/**
 * Checks whether a given URL is for an SVG symbol.
 *
 * @param url URL of SVG to load.
 */
export function isUrlSymbol(url: string): boolean {
  return url.charAt(0) === '#' || url.indexOf('.svg#') > -1;
}

/**
 * Checks whether SVGs are supported.
 */
export function isSvgSupported(): boolean {
  return typeof SVGRect !== 'undefined';
}

/**
 * Extracts the symbol from the given SVG into its own SVG element, using
 * a `<use>` tag.
 *
 * @param svg The SVG to get the symbol from.
 * @param symbolId The ID of the symbol.
 */
export function createSymbolSvg(
  renderer: Renderer2, svg: SVGElement, symbolId: string): SVGElement {

  const symbol = svg.querySelector(`symbol[id="${symbolId}"]`);
  if (!symbol) {
    throw new Error(`Symbol "${symbolId}" not found`);
  }

  // Neues SVG-Element erstellen
  const elSvg = renderer.createElement('svg', 'svg');

  // Alle Attribute vom <symbol> auf das neue SVG übertragen, außer Klassen
  Array.from(symbol.attributes).forEach(attr => {
    if (attr.name !== 'class') {
      elSvg.setAttribute(attr.name, attr.value);
    }
  });

  // Alle Inhalte von <symbol> in das neue <svg> kopieren
  const elements = Array.from(symbol.children);
  elements.forEach(el => {
    elSvg.appendChild(el.cloneNode(true));
  });

  // Symbol aus dem ursprünglichen SVG entfernen
  symbol.remove();

  return elSvg;
}

/**
 * Removes attributes from an element.
 *
 * @param element Element with attributes.
 * @param attrs Names of attributes to remove.
 */
export function removeAttributes(element: Element, attrs: Array<string>): void {
  attrs.forEach(attr => {
    if (element.hasAttribute(attr)) {
      element.removeAttribute(attr);
    }
  });

  // Alle Kinder-Elemente bearbeiten
  const innerElements = Array.from(element.querySelectorAll('*'));
  innerElements.forEach(innerEl => {
    attrs.forEach(attr => {
      if (innerEl.hasAttribute(attr)) {
        innerEl.removeAttribute(attr);
      }
    });
  });
}

/**
 * Sets attributes on an element.
 *
 * @param element Element to set attributes on.
 * @param attrs Attribute key/values.
 */
export function setAttributes(element: Element, attrs: { [key: string]: any }): void {
  for (const attr in attrs) {
    element.setAttribute(attr, attrs[attr]);
  }
}